import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Button, IconButton, InputAdornment, TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import UserGroups from "./UserGroups";
import {
  UserGroupsModalProps,
  IGroup,
  IAddUser,
} from "./UserGroupsInterfaces";
import blogFetch from "../../axios/config";
import language from "../../nls/language.json";
import Context from "../../context/Context";
import { getCookie } from "../../section/cookie";
import toast from "react-hot-toast";


const UserGroupsModal: React.FC<UserGroupsModalProps> = ({
  open,
  onClose,
  user,
}) => {

  const [oldUser, setOldUser] = useState<IAddUser>({
      User_Active: true,
      user_CompanyId: 1,
      user_Password: "",
      User_Email: "",
      user_UserName: "",
      User_Matricula: 0,
      User_SAPMatricula: 0,
      user_Sector: null
    });

  const [oldName, setOldName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [passwordsMatch, setPasswordsMatch] = useState<boolean>(true);
  const [groups, setGroups] = useState<IGroup[]>([]);
  const [data, setData] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  

  const {
    selectedCountry,
  } = useContext(Context);


  const getUsers = async () => {
    
    try {

      if (!user?.user_Id) {
        console.error("ID do usuário não definido.");
        return;
      }
      
      const response = await blogFetch.get(`/user/${user.user_Id}`);
      const data = response.data;


      if (!data) {
        console.error("Dados do usuário não encontrados.");
        return;
      }

      console.log(data)

      setOldUser({
        ...oldUser,
        user_CompanyId: data.user_CompanyId || "",
          User_Email: data.user_Email || "",
          user_UserName: data.user_UserName || "",
          User_Matricula: data.user_Matricula || "",
          User_SAPMatricula: data.user_SAPMatricula || "",
          user_Sector: data.user_Sector || "",
        });

      setOldName(data.user_UserName || "");

    } catch (error) {
      console.error("Erro ao buscar usuário:", error);
    }
  };

  useEffect(() => {
    getUsers();
  }, [user?.user_Id]);

  //#region handleUser


  const handleChangeNumber = (key: keyof typeof oldUser) => 
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      const intValue = parseInt(value, 10);
  
      if (!isNaN(intValue)) {
        setOldUser((prevUser) => ({
          ...prevUser,
          [key]: intValue,
        }));
      }
    };

    const handleChangeText = (key: keyof typeof oldUser) => 
      (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        setOldUser((prevUser) => ({
          ...prevUser,
          [key]: value,
        }));
      };

      const handleChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
      };
      
      const handleChangeConfirmPassword = (event: React.ChangeEvent<HTMLInputElement>) => {
        setConfirmPassword(event.target.value);
      };

      const handleChangeMatricula = handleChangeNumber('User_Matricula');
      const handleChangeSAPLogin = handleChangeNumber('User_SAPMatricula');
      const handleChangeUserName = handleChangeText('user_UserName');
      const handleChangeEmail = handleChangeText('User_Email');

  //#endregion

  //#region updateUser

  const updateUser = async () => {
    
    if (password && password !== confirmPassword) {
      setPasswordsMatch(false);
      return;
    }
  
    setPasswordsMatch(true);
    setLoading(true);
  
    const id = user?.user_Id;

    const {
      user_CompanyId,
      user_UserName,
      User_Email,
      User_Matricula,
      User_SAPMatricula,
      User_Active,
      user_Sector,
      user_Password,
    } = oldUser;
  
    
    const updateUser: IAddUser = {
      user_CompanyId,
      user_Password: password || user_Password,
      user_UserName,
      User_Email,
      User_Matricula,
      User_SAPMatricula,
      User_Active,
      user_Sector,
    };
  
    try {
      await blogFetch.put(`/user/${id}`, updateUser);
      
      setTimeout(() => {
        setLoading(false);
      }, 500);


      toast.success('Usuario atualizado com sucesso')
      onClose();

      
      
    } catch (error) {
      console.error("Erro ao atualizar usuário:", error);
  
      
      alert("Ocorreu um erro ao atualizar o usuário. Tente novamente.");
  
      setLoading(false);
    }
  };

  //#endregion




  const updateUserGroups = async () => {
    setLoading(true);

    updateUser()

    try {
      const newListUserGroups = [];

      for (const group of groups) {
        if (group.checked) {
          const newUserGroup = {
            UsersGroups_GroupId: group.group_Id,
            UsersGroups_UserId: user?.user_Id,
          };
          newListUserGroups.push(newUserGroup);
        }
      }

      const response = await blogFetch.post(
        `/UsersGroups/lote_`,
        newListUserGroups
      );

      const data = response.data;

      setTimeout(() => {
        setLoading(false);
      }, 500);

  

      return data;
    } catch (error) {
      console.error(error);
      setTimeout(() => {
        setLoading(false);
      }, 500);

      throw error;
    }
  };

  return (
    <Modal show={open} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {user
            ? `${(language as Record<string, any>)[selectedCountry.name].Permissoes.usuario.modal.editar.titleUser} ${oldName != null ? oldName.toUpperCase() : user.user_Matricula}`
            : (language as Record<string, any>)[selectedCountry.name].Permissoes.usuario.modal.editar.titleNotUser}
          {data}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <TextField
              
              className="mb-3"
              id="outlined-basic"
              label="Login"
              variant="outlined"
              fullWidth
              value={oldUser?.user_UserName || ""}
              onChange={handleChangeUserName}
              sx={{ backgroundColor: "white", borderRadius: "5px" }}
            />
            <TextField
              
              className="mb-3"
              id="outlined-basic"
              label="SAP Login"
              variant="outlined"
              fullWidth
              value={oldUser?.User_SAPMatricula || ""}
              onChange={handleChangeSAPLogin}
              sx={{ backgroundColor: "white", borderRadius: "5px" }}
            />
            <TextField
              className="mb-3"
              id="outlined-basic"
              label="Matrícula"
              variant="outlined"
              fullWidth
              value={oldUser?.User_Matricula || ""}
              onChange={handleChangeMatricula}
              sx={{ backgroundColor: "white", borderRadius: "5px" }}
            />
            <TextField
              className="mb-3"
              id="outlined-basic"
              label="Email"
              variant="outlined"
              fullWidth
              value={oldUser?.User_Email || ""}
              onChange={handleChangeEmail}
              sx={{ backgroundColor: "white", borderRadius: "5px" }}
            />
            <TextField
              className="mb-3"
              id="outlined-basic"
              label="Nova Senha "
              variant="outlined"
              fullWidth
              type="password"
              onChange={handleChangePassword}
            />
            <TextField
              className="mb-3"
              id="outlined-basic"
              label="Confirmar Senha"
              variant="outlined"
              fullWidth
              type="password"
              onChange={handleChangeConfirmPassword}
            />
            {passwordsMatch ? null : (
              <p style={{ color: "red", fontSize: "14px" }}>
                {(language as Record<string, any>)[selectedCountry.name].Permissoes.config.senhasIncorretas}
              </p>
            )}
        </div>
      </Modal.Body>
      <Modal.Body>
        {user && (
          <UserGroups
            user={user}
            onClose={onClose}
            groups={groups}
            setGroups={setGroups}
          />
        )}
      </Modal.Body>
      <Modal.Footer >
        <Button variant="text" onClick={onClose}>
          {(language as Record<string, any>)[selectedCountry.name].Permissoes.usuario.modal.editar.btnCancelar}
        </Button>
        {loading ? (
          <LoadingButton loading variant="outlined">
            Submit
          </LoadingButton>
        ) : (
          <Button variant="contained" onClick={updateUserGroups}>
            {(language as Record<string, any>)[selectedCountry.name].Permissoes.usuario.modal.editar.btnSalvar}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default UserGroupsModal;
